import { createSlice } from '@reduxjs/toolkit';
import { func_validation } from 'functions';

export const commitmentPaySetupSlices = createSlice({
	name: 'commitmentPaySetup',
	initialState: {},
	reducers: {
		// Get All Revenue Recognition Plan
		getRevRecPlanList_request: (state) => {
			state.getRevRecPlanList_requesting = true;
			state.getRevRecPlanList_isSuccessful = undefined;
		},
		getRevRecPlanList_success: (state, action) => {
			state.getRevRecPlanList_requesting = false;
			state.getRevRecPlanList_isSuccessful = true;
			state.revRecPlanListTotalRecords = action?.payload?.totalCount;

			let data =  action?.payload?.plans;
			if (data) {
				let plansList_formatted = [];
				if (func_validation.isArrayNotEmpty(data)) {
					plansList_formatted = func_validation.cloneArrayOfObject(data);
					plansList_formatted.map((plansDetail, plansIndex) => {
						let obj = {};
						if(func_validation.isArrayNotEmpty(plansDetail?.referenceKeyInfo)) {
							obj["referenceKeyInfo"] = [...plansDetail.referenceKeyInfo];
							plansList_formatted[plansIndex]["subRows"] = [];
							plansList_formatted[plansIndex]["subRows"].push(obj);
						}
					})
				}
				state.revRecPlanList = plansList_formatted;
			}
		},
		getRevRecPlanList_failure: (state) => {
			state.getRevRecPlanList_requesting = false;
			state.getRevRecPlanList_isSuccessful = false;

			state.revRecPlanList = [];
			state.revRecPlanListTotalRecords = 0;
		},

		// Get Specific Plan
		getPlanByComId_request: (state) => {
			state.getPlanByComId_requesting = true;
			state.getPlanByComId_isSuccessful = undefined;
		},
		getPlanByComId_success: (state, action) => {
			state.getPlanByComId_requesting = false;
			state.getPlanByComId_isSuccessful = true;

			let data =  action?.payload;
			state.currentPlan = func_validation.isObjectNotEmpty(data)? data:[]
		},
		getPlanByComId_failure: (state) => {
			state.getPlanByComId_requesting = false;
			state.getPlanByComId_isSuccessful = false;
		},
		
		// Update Netsuite Plan
		updatePlan_request: (state, action) => {
            state.updatePlan_requesting = true;
            state.isPlanUpdatedSuccessfully = undefined;
        },
        updatePlan_success: (state, action) => {
            state.updatePlan_requesting = false;
            state.isPlanUpdatedSuccessfully = true;
        },
        updatePlan_failure: (state, action) => {
            state.updatePlan_requesting = false;
            state.isPlanUpdatedSuccessfully = false;
        },

		// Sync down debit notes
		syncDownDebitNotes_request: (state, action) => {
            state.syncDownDebitNotes_requesting = true;
            state.isSyncDownDebitNotesSuccessfully = undefined;
        },
        syncDownDebitNotes_success: (state, action) => {
            state.syncDownDebitNotes_requesting = false;
            state.isSyncDownDebitNotesSuccessfully = true;
        },
        syncDownDebitNotes_failure: (state, action) => {
            state.syncDownDebitNotes_requesting = false;
            state.isSyncDownDebitNotesSuccessfully = false;
        },

		// Switch to commitment plan
		switchCommitmentPlan_request: (state, action) => {
            state.switchCommitmentPlan_requesting = true;
            state.isSwitchCommitmentPlanSuccessfully = undefined;
        },
        switchCommitmentPlan_success: (state, action) => {
            state.switchCommitmentPlan_requesting = false;
            state.isSwitchCommitmentPlanSuccessfully = true;
        },
        switchCommitmentPlan_failure: (state, action) => {
            state.switchCommitmentPlan_requesting = false;
            state.isSwitchCommitmentPlanSuccessfully = false;
        },
	},
});

export const { 
	getRevRecPlanList_request,
    getRevRecPlanList_success,
    getRevRecPlanList_failure,
	getPlanByComId_request,
	getPlanByComId_success,
	getPlanByComId_failure,
	updatePlan_request,
	updatePlan_success,
	updatePlan_failure,
	syncDownDebitNotes_request,
	syncDownDebitNotes_success,
	syncDownDebitNotes_failure,
	switchCommitmentPlan_request,
	switchCommitmentPlan_success,
	switchCommitmentPlan_failure
} = commitmentPaySetupSlices.actions;

export default commitmentPaySetupSlices.reducer;